import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ConfigurationService } from '@sondermind/configuration';
import { PublicHeaderModule } from '@sondermind/features/app-header';
import { IrisButtonContainerMobileLayouts, IrisButtonModule } from '@sondermind/iris/button';
import { IrisButtonTypeAttributeOptions } from '@sondermind/iris/shared';

@Component({
  selector: 'page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
  imports: [
    CommonModule,
    IrisButtonModule,
    PublicHeaderModule
  ]
})

export class PageNotFoundComponent implements OnInit {
  @Input() buttonTitle: string = 'Find care';
  @Input() redirectUrl: string = '';
  @Input() showHeader: boolean = false;

  IrisButtonContainerMobileLayouts = IrisButtonContainerMobileLayouts;
  IrisButtonTypeAttributeOptions = IrisButtonTypeAttributeOptions;

  constructor(
    private route: ActivatedRoute,
    private configurationService: ConfigurationService
  ) {}

  ngOnInit(): void {
    const { showHeader, redirectUrl } = this.route.snapshot.data;
    if (!this.redirectUrl && redirectUrl) {
      this.redirectUrl = `${this.configurationService.env.providerDirectoryBase}/${redirectUrl}`;
    }
    if (!this.showHeader && showHeader) {
      this.showHeader = showHeader;
    }
  }
}
